{
  "app_name": "SKILLMAP",
  "tagline": "Skills Mapping",
  "bp_level_placeholder": "Not defined yet",
  "logout": "Log out",
  "no_data": "No data available",
  "coming_soon_lot4": "Available after campaign / analytics lot",
  "nav_dashboard": "Dashboard",
  "nav_assessment": "My Assessment",
  "nav_bpml": "BPML",
  "nav_analytics": "Analytics",
  "nav_admin": "Administration",
  "nav_export": "Export",
  "nav_notifications": "Notifications",
  "nav_audit": "Audit Log",
  "nav_profile": "My Profile",
  "validation_dashboard": "Validation Dashboard",
  "pending_submissions": "Submitted sessions to review or validate",
  "validate": "Validate",
  "return_to_expert": "Return to expert",
  "force_validate": "Force validate",
  "confirm_force_validate": "Force validation? Enter a mandatory reason.",
  "mandatory_comment": "A comment for the expert is required.",
  "comment": "Comment",
  "reason": "Reason",
  "cancel": "Cancel",
  "review": "Review",
  "open": "Open",
  "status": "Status",
  "all": "All",
  "submission_date": "Submission date",
  "validate_failed": "Validation failed",
  "return_failed": "Return failed",
  "user_management": "User Management",
  "import_users": "Import users",
  "referentials": "Referentials",
  "erp_scale": "Application & scale",
  "bpml_import": "BPML Import",
  "bpml_enrichment": "BPML Enrichment",
  "transversal_skills": "Transversal Skills",
  "transversal_shared_hint": "Transversal skills are not tied to any domain: one assessment per year, one submission.",
  "feature_self_eval": "Application Feature Proficiency",
  "feature_self_eval_sub": "Rate your proficiency on each application feature relevant to this assessment. These scores are shared across all your assessments for the year.",
  "no_feature_lines": "No application features linked to this assessment",
  "heat_map": "Heat Map",
  "radar_chart": "Radar Chart",
  "gap_analysis": "Gap Analysis",
  "individual_progression": "Individual Progression",
  "team_coverage": "Team Coverage",
  "training_needs": "Training Needs",
  "distribution": "Distribution",
  "transversal_team": "Transversal team",
  "role_admin": "Administrator",
  "role_manager": "Domain Manager",
  "role_expert": "Expert",
  "status_draft": "Draft",
  "status_submitted": "Submitted",
  "status_validated": "Validated",
  "assessments": "Assessments",
  "new_assessment": "New Assessment",
  "save_draft": "Save Draft",
  "submit_assessment": "Submit Assessment",
  "lines_scored": "lines scored",
  "add_comment": "Add comment",
  "back_to_list": "List",
  "loading": "Loading…",
  "confirm_submit": "Submit this assessment? Scores will no longer be editable.",
  "delete_draft": "Delete draft",
  "confirm_delete_draft": "Delete this draft? The expert can create a new one on the active BPML. Scores in this draft will be lost (year transversal scores are kept).",
  "delete_draft_failed": "Could not delete the draft",
  "read_only_owner": "Read-only (you are not the owner).",
  "full_name": "Full Name",
  "domain": "Domain",
  "erp": "Application",
  "year": "Year",
  "active": "Active",
  "inactive": "Inactive",
  "user_id": "User ID",
  "select_user": "User",
  "no_users_found": "No users available",
  "progression_hint": "The chart uses submitted or validated sessions, by year and macro-process.",
  "progression_select_hint": "Select a user to display their progression.",
  "progression_empty_hint": "No progression data for {{name}}. At least one submitted or validated session is required.",
  "target_threshold": "Target threshold",
  "complexity_index": "Complexity index",
  "gap": "Gap",
  "gaps_none": "All lines meet the target threshold",
  "above_target": "Above target",
  "critical": "Critical",
  "spof_risk": "SPOF",
  "weight_by_ci": "Weight by complexity index",
  "cumulative_gap": "Cumulative gap",
  "training_none": "No training needs identified",
  "functional_skills": "Functional skills",
  "business_processes": "business processes",
  "sub_processes": "sub-processes",
  "radar_axes_business": "skills (aggregated)",
  "radar_zoom": "Zoom / detail",
  "radar_zoom_aggregated": "Aggregated (e.g. Power BI)",
  "radar_zoom_back": "Back to aggregated",
  "radar_zoom_up": "Zoom out one level",
  "radar_drill_hint": "Drill down where several sub-items exist:",
  "radar_grain_macro": "macro-processes",
  "radar_grain_task": "tasks",
  "categories": "categories",
  "avg_score": "Average score",
  "score_count": "Score count",
  "analytics_load_failed": "Failed to load analytics",
  "analytics_hub": "Analytics summary",
  "analytics_hub_sub": "Risk & campaign insights — expand sections as needed",
  "insight_critical_ie": "Critical processes — Internal vs External",
  "insight_spof": "Critical SPOF / uncovered",
  "insight_campaign": "Campaign readiness",
  "insight_more_views": "Detailed views & catalogue",
  "workforce_internal": "Internal ≥ target",
  "workforce_external": "External ≥ target",
  "only_external": "External only",
  "uncovered": "Uncovered",
  "spof_none": "No critical SPOF or uncovered lines",
  "analytics_catalog_hint": "Remaining catalogue: critical×CI heatmap, multi-application, comment density…",
  "domain_bench": "Domain bench",
  "domain_bench_sub": "Average scores and % of cells at threshold by domain",
  "plaque_view": "Plaque / country",
  "plaque_view_sub": "Expert and score distribution by geographic plaque and country",
  "rare_expertise": "Rare expertise",
  "rare_expertise_sub": "BPML lines with only 1 or 2 experts at threshold (0-expert lines are out of this view)",
  "feature_heatmap": "Feature Heatmap",
  "feature_heatmap_title": "Application Skills Heatmap",
  "feature_heatmap_sub": "Score grid: experts × application features (from My Application Skills)",
  "all_modules": "All modules",
  "module": "Module (N1)",
  "avg": "Avg",
  "coverage_pct": "Cov.",
  "no_module": "No module",
  "no_submodule": "No sub-module",
  "feature_gap": "Feature Gap Analysis",
  "feature_gap_title": "Feature Gap Analysis",
  "feature_gap_sub": "Cross-references BPML feature needs with team application skill scores to identify gaps and risks.",
  "bpml_lines_col": "BPML lines",
  "critical_lines_col": "Critical",
  "experts_above_col": "Experts ≥ target",
  "avg_score_col": "Avg score",
  "concerned_processes_col": "Concerned processes",
  "risk_filter": "Risk filter",
  "all_risks": "All risks",
  "all_domains": "All domains",
  "total_features_needed": "Features needed",
  "team_size": "Team size",
  "uncovered_features": "features with 0 experts above threshold",
  "no_results_for_filter": "No features match the current filter.",
  "pct_at_threshold": "% ≥ threshold",
  "experts": "Experts",
  "by_plaque": "By plaque",
  "by_country": "By country",
  "experts_by_plaque": "Headcount by plaque",
  "plaque": "Plaque",
  "country": "Country",
  "plaque_manager_hint": "Scores hidden when fewer than {{min}} experts (k-anonymity)",
  "plaque_countries_admin_only": "Country-level detail is Admin-only.",
  "rare_single": "1 expert",
  "rare_two": "2 experts",
  "rare_none": "No rare expertise in scope",
  "campaigns": "Campaigns",
  "campaigns_sub": "Per-domain tracking: status, progress, schedule",
  "campaign_tab_board": "Dashboard",
  "campaign_tab_template": "Year template",
  "campaign_tab_suivi": "Status tracking",
  "campaign_tab_calendar": "Schedule & actions",
  "campaign_create_all": "Create campaigns for all domains",
  "campaign_create_all_hint": "Creates missing campaigns and reapplies the template to unused ones (draft or prep, with no scores yet). Open or already used campaigns are skipped. A saved year template is required.",
  "campaign_create_all_confirm_update": "Reapply the template to {{count}} unused campaign(s) ({{domains}})? Open or already used campaigns will not be changed.",
  "campaign_generate_need_template": "Save the year template for {{year}} (Year template tab) before creating or regenerating campaigns.",
  "campaign_missing_domains": "{{count}} active domain(s) have no campaign for {{year}}.",
  "campaign_generate_done": "Generation complete — created: {{created}} · updated: {{updated}} · skipped: {{skipped}}",
  "campaign_none_year": "No campaigns for this year.",
  "campaign_suivi_title": "Campaign tracking",
  "campaign_suivi_hint": "Status per domain and self-assessment progress (draft + submitted = in progress, validated = validated).",
  "campaign_suivi_process_section": "Process self-assessments (BPML)",
  "campaign_suivi_transversal_section": "Transversal self-assessments (counted per expert's attached domain)",
  "campaign_suivi_col_in_progress": "In progress",
  "campaign_suivi_col_validated": "Validated",
  "campaign_suivi_col_total": "Total sessions",
  "campaign_suivi_col_campaign_status": "Campaign",
  "campaign_suivi_features_section": "Application features tracking",
  "campaign_suivi_features_hint": "For each (tracking) domain and application, number of experts whose feature grid is complete (all active features scored) out of the total experts attached to the domain.",
  "campaign_suivi_col_experts": "Experts",
  "campaign_suivi_features_missing_badge": "Missing features",
  "campaign_suivi_features_missing_hint": "This active application has no active features defined: the completion shown is automatic (0/0) and does not reflect a real self-assessment.",
  "dashboard_title": "Dashboard",
  "dashboard_subtitle": "Overview of ongoing campaigns — click a card for details.",
  "dashboard_kpi_pending_validations": "Pending validations",
  "dashboard_kpi_pending_validations_detail": "{{process}} process · {{transversal}} transversal",
  "dashboard_kpi_process": "Process — validated",
  "dashboard_kpi_process_detail": "{{inProgress}} in progress · {{validated}} validated out of {{total}}",
  "dashboard_kpi_transversal": "Transversal — validated",
  "dashboard_kpi_transversal_detail": "{{inProgress}} in progress · {{validated}} validated out of {{total}}",
  "dashboard_kpi_features": "Application features — completed",
  "dashboard_kpi_features_detail": "{{completed}}/{{total}} complete grids",
  "dashboard_detail_hint": "For the breakdown by domain, see the",
  "campaign_banner": "Campaign {{domain}} {{year}} ({{status}})",
  "campaign_deadline": "submit by {{date}}",
  "campaign_step_end_before_start": "The end date for “{{step}}” must be on or after its start date.",
  "campaign_template_date_hint": "For each step, the end date must be on or after the start date. Step end → next start = next day (if empty).",
  "preevals": "Pre-evaluations",
  "preevals_sub": "Manager view of skills (separate from Expert scores) — optional campaign step",
  "new_preeval": "New pre-eval",
  "new_preeval_sub": "Pick expert, domain, application (optional) and year. Scores stay invisible to the expert.",
  "create_and_score": "Create and score",
  "preeval_gaps": "Expert / Manager gaps",
  "preeval_gaps_sub": "Compare after Expert self-assessment: delta = Expert score − Manager score",
  "preeval_gaps_only_diff": "Non-zero gaps only",
  "preeval_gaps_formula": "Positive Δ = Expert higher than Manager; negative Δ = Expert lower.",
  "preeval_for": "Pre-eval for",
  "preeval_privacy_hint": "These scores stay Manager/Admin-only — the expert never sees them.",
  "submit_preeval": "Submit pre-eval",
  "confirm_submit_preeval": "Submit this pre-evaluation? It will become read-only.",
  "confirm_submit_preeval_empty": "No scores entered. Submit anyway (read-only)?",
  "preeval_gaps_empty": "No Manager pre-eval scores for these filters — or the expert has not submitted yet.",
  "preeval_gaps_no_diff": "No non-zero gaps (uncheck « non-zero only » to see all).",
  "preeval_pending": "remaining",
  "preeval_complete": "all scored",
  "preeval_filter_pending": "Unscored",
  "preeval_score_hint": "Click a score to rate; click again to clear. Green row = already scored.",
  "preeval_not_scored": "Not scored",
  "preeval_line_scored": "Scored: {{score}}",
  "preeval_line_pending": "To score",
  "preeval_progress_col": "Entry progress",
  "preeval_fill_none": "Not started",
  "preeval_fill_partial": "In progress",
  "preeval_fill_full": "Complete",
  "preeval_continue": "Continue",
  "preeval_tv_shared_hint": "Transversal skills: one Manager view per expert and year — shared if the expert has several domains / applications (same rule as Expert self-assessment).",
  "save": "Save",
  "preeval_scale_legend": "Score scale",
  "preeval_compare": "Compare with self-assessment",
  "preeval_compare_ready": "Expert self-assessment available ({{status}}). Line-by-line gaps below (Expert vs your score).",
  "preeval_compare_waiting": "Comparison unlocks once the expert has submitted (or validated) their self-assessment for this domain / application / year.",
  "preeval_open_assessment": "Open self-assessment",
  "preeval_filter_gaps": "Gaps",
  "preeval_expert_short": "Expert",
  "preeval_expert_na": "Expert —",
  "preeval_compare_hint": "Δ = Expert score − your Manager score",
  "export_sub": "Async Excel export of scores (BPML + Transversal) — download as soon as ready",
  "export_new": "New request",
  "export_hint": "Two sheets: BPML and Transversal. Generated in a few seconds; file stays downloadable ~24h. An email is sent when the export is ready (or failed).",
  "export_start": "Start export",
  "export_jobs": "My exports",
  "export_created": "Requested at",
  "export_download": "Download",
  "export_wait": "In progress…",
  "export_status_filter": "Sessions included",
  "export_status_submitted_validated": "Submitted + validated",
  "export_status_validated_only": "Validated only",
  "export_status_queued": "Queued",
  "export_status_running": "Running",
  "export_status_ready": "Ready",
  "export_status_failed": "Failed",
  "export_load_failed": "Failed to load exports",
  "export_request_failed": "Export request failed",
  "export_download_failed": "Download failed",
  "notif_sub": "Deadline reminders and email send log (SMTP / DEV console)",
  "notif_offsets": "Reminder offsets",
  "notif_offsets_hint": "Days before the campaign SUBMIT_DEADLINE (e.g. 14, 3, 0 = J-14, J-3, day J). Timezone Europe/Paris.",
  "notif_offsets_label": "Offsets (days, comma-separated)",
  "notif_mail_mode": "Send mode",
  "notif_last_run": "Last run",
  "notif_run_now": "Run reminders now",
  "notif_recent": "Recent sends",
  "notif_type": "Type",
  "notif_recipient": "Recipient",
  "notif_sent_at": "Sent at",
  "notif_load_failed": "Could not load notification settings",
  "notif_save_failed": "Could not save",
  "notif_saved": "Offsets saved",
  "notif_run_failed": "Reminder run failed",
  "notif_run_result": "Reminders: {{sent}} sent, {{skipped}} skipped, {{failed}} failed — {{candidates}} candidate(s)",
  "assessments_sub": "Sessions by domain, application (optional) and year.",
  "assessments_load_failed": "Could not load assessments",
  "scores_progress": "Scores",
  "audit_sub": "Append-only events with change details — Admin only",
  "audit_search": "Search",
  "audit_search_ph": "Action, actor, target…",
  "audit_action": "Action",
  "audit_from": "From",
  "audit_to": "To",
  "audit_when": "When",
  "audit_actor": "Actor",
  "audit_target": "Target",
  "audit_details": "Changes",
  "audit_total": "{{total}} event(s)",
  "audit_prev": "Previous",
  "audit_next": "Next",
  "audit_page": "Page {{page}} / {{totalPages}}",
  "audit_load_failed": "Could not load audit log",
  "load_failed": "Could not load",
  "save_failed": "Could not save",
  "create_failed": "Could not create",
  "update_failed": "Could not update",
  "download_failed": "Could not download",
  "import_failed": "Import failed",
  "activate_failed": "Could not activate",
  "transition_failed": "Could not change status",
  "generate_failed": "Could not generate",
  "save_template_failed": "Could not save the template",
  "sync_bpml_failed": "Could not sync BPML lines",
  "submit_failed": "Could not submit",
  "choose_xlsx": "Choose an Excel file (.xlsx).",
  "version_label_required": "Enter a version label.",
  "yes": "Yes",
  "no": "No",
  "filter": "Filter",
  "edit": "Edit",
  "add": "Add",
  "import": "Import",
  "activate": "Activate",
  "deactivate": "Deactivate",
  "actions": "Actions",
  "code": "Code",
  "label_en": "Label EN",
  "label_fr": "Label FR",
  "matricule": "Employee ID",
  "email_label": "Email",
  "role": "Role",
  "language": "Language",
  "department": "Department",
  "population": "Population",
  "workforce": "Internal / External",
  "workforce_internal_opt": "Internal",
  "workforce_external_opt": "External",
  "coming_soon_body": "Screen planned (SkillMap V0). Available after the campaign / analytics lot.",
  "api_network_error": "Could not reach the API (network, CORS, or timeout). On hosted DEV, a large user import often exceeds 29s — split the Excel file.",
  "required_domain_erp": "Domain is required.",
  "required_expert_domain_erp": "Expert and domain are required.",
  "required_expert_domain": "Expert and domain are required.",
  "session_exists": "Session already exists — open it from the list.",
  "new_assessment_sub": "Choose domain, application (optional) and year. If an application is selected, only the BPML lines for that application are pre-filled; otherwise all BPML lines are included.",
  "complexity_short": "(Complex.: {{n}})",
  "bpml_line": "BPML line",
  "self_assessment_short": "Self-assessment",
  "experts_not_found": "Experts not found",
  "load_lines_failed": "Could not load lines",
  "load_skills_failed": "Could not load skills",
  "login_subtitle": "Skills vs BPML — Arkema IT",
  "login_api_unreachable": "Could not reach the API (login-config). Start the backend (port 4000) then reload.",
  "login_hint_fallback": "login-config API unreachable — password = SEED_DEV_PASSWORD / backend/.env.",
  "login_dev_hint_note": "DEV admin account — password is in SEED_DEV_PASSWORD / backend/.env (never exposed by the API).",
  "login_dev_only": "DEV only",
  "login_user": "User:",
  "login_sso_body": "This environment uses SSO (OIDC / Cognito). Password login is disabled.",
  "login_sso_soon": "Sign in with SSO (coming soon)",
  "login_sso_title": "SSO to be wired (Phase 2)",
  "login_identifier": "Email or employee ID",
  "login_identifier_ph": "firstname.lastname@arkema.com or A6049046",
  "login_password": "Password",
  "login_show_password": "Show password",
  "login_hide_password": "Hide password",
  "login_submit": "Sign in",
  "login_submitting": "Signing in…",
  "login_footer": "In production: Arkema SSO/OIDC — identifier provided automatically",
  "login_locked": "Account temporarily locked after too many failed attempts. Try again later.",
  "login_sso_required": "Password login is disabled. Use SSO.",
  "login_bad_credentials": "Incorrect identifier or password.",
  "login_connect_failed": "Could not sign in. Check that the backend is running.",
  "campaign_step_BPML_READY": "BPML ready",
  "campaign_step_ENRICH": "Enrichment",
  "campaign_step_PREEVAL": "Pre-evaluation (opt.)",
  "campaign_step_EXPERT_ENTRY": "Expert entry",
  "campaign_step_SUBMIT_DEADLINE": "Submission deadline",
  "campaign_step_VALIDATION": "Validation",
  "campaign_step_ANALYSIS": "Analysis",
  "campaign_status_draft": "Draft",
  "campaign_status_prep": "Preparation",
  "campaign_status_open": "Open",
  "campaign_status_closed": "Closed",
  "campaign_phase_not_started": "Not started",
  "campaign_phase_in_progress": "In progress",
  "campaign_phase_blocked": "Blocked",
  "campaign_phase_delayed": "Delayed",
  "campaign_phase_done": "Done",
  "campaign_phase_skipped": "Skipped",
  "campaign_board_phases": "Phase dashboard",
  "campaign_board_hint": "Status of each step per domain. Click a cell to update status and comment.",
  "campaign_kpi_blocked": "Blocked",
  "campaign_kpi_delayed": "Delayed (status)",
  "campaign_kpi_in_progress": "In progress",
  "campaign_kpi_overdue": "Overdue",
  "deadline": "Deadline",
  "comment_ph": "Comment…",
  "calendar": "Calendar",
  "year_template_title": "Year template {{year}}",
  "campaign_template_manager_hint": "The date template is managed by the Administrator. You can review your campaign calendar in the Schedule & actions tab.",
  "campaign_template_admin_hint": "Set each step’s dates once for the year, then generate campaigns for all domains (button below or at the top of the page). Campaigns can also be created without dates: fill them in here or in the calendar afterwards.",
  "step": "Step",
  "starts_on": "Start",
  "ends_on": "End",
  "required_short": "Req.",
  "save_template": "Save template",
  "template_last_update": "Template last updated",
  "select_campaign": "Select a campaign.",
  "to_prep": "→ Preparation",
  "close_campaign": "Close",
  "allow_manager_dates": "Allow the Manager to edit dates",
  "dates_readonly_admin": "Dates are read-only (Admin).",
  "campaign_open_hint": "To open: submission deadline + active BPML. Step end → next start = next day (if empty).",
  "preevals_manager_link": "Manager pre-evaluations →",
  "preevals_optional_hint": "(optional step — scores are outside the Expert self-assessment)",
  "create_user": "Create user",
  "edit_user": "Edit user",
  "search_users": "Search (ID, email, name)",
  "temp_password_once": "Temporary password (share once):",
  "password_optional": "Password (optional — otherwise generated)",
  "account_active": "Account active",
  "reset_password": "Reset password",
  "reset_password_confirm": "Reset password for {{id}}?",
  "reset_password_prompt": "New password (min. 12 characters) — leave empty to generate:",
  "reset_failed": "Could not reset password",
  "users_sub": "Accounts, roles, domains and local password",
  "manager": "Manager (line)",
  "matrix_managers": "Matrix managers",
  "matrix_managers_hint": "Matrix reports (read-only view of the expert's results).",
  "matrix_short": "matrix",
  "import_xlsx": "Import (.xlsx)",
  "back_users": "← Back to users",
  "import_users_title": "Import users (Excel)",
  "import_users_help": "Columns: internalId, email, fullName, role, population, language, country, domains, department. The country column (ISO alpha-2) is required. Role / population / language / country / domains / department: Admin referential codes or labels — case-insensitive. Multi-sheet template: data is read from the Donnees tab (not Guide).",
  "download_excel_template": "Download Excel template",
  "import_in_progress": "Import in progress…",
  "report": "Report",
  "created_n": "Created",
  "updated_n": "Updated",
  "features_linked_n": "Features linked",
  "errors_n": "Errors",
  "excel_row": "Excel row {{row}}:",
  "row_n": "Row {{row}}:",
  "referentials_sub": "Values used in forms and Excel imports. Countries: plaque EMEA / AMAS / APOC / GC (CN = Greater China, outside APOC).",
  "ref_kind_departments": "Departments",
  "ref_kind_domains": "Domains",
  "ref_kind_countries": "Countries",
  "ref_kind_roles": "Roles",
  "ref_kind_populations": "Populations",
  "ref_kind_languages": "Languages",
  "import_excel_kind": "Excel import — {{kind}}",
  "import_excel_templates": "Templates 01–06 (Donnees sheet). Upsert by code.",
  "no_entries": "No entries",
  "access_level": "Access level",
  "system_entry_hint": "* system entry (seed) — code cannot be changed; labels / plaque / status can",
  "edit_code": "Edit — {{code}}",
  "add_kind": "Add — {{kind}}",
  "code_immutable": "The code cannot be changed",
  "parent_department": "Parent department (required)",
  "parent_department_opt": "— Department —",
  "geo_plaque": "Geographic plaque",
  "access_level_hint": "Access level (100=admin, 50=manager, 10=expert)",
  "erp_scale_title": "Application & scale configuration",
  "erp_list": "Application list",
  "environments_title": "Application Environments",
  "environments_desc": "Environments represent specific instances of an application (e.g. NICE and BEST for SAP). BPML lines tagged with environments generate separate assessment lines per environment.",
  "new_environment_label": "Environment name (e.g. NICE)",
  "no_environments_yet": "No environments yet. Use the form above to add one.",
  "select_application": "Application",
  "required_application": "Please select an application",
  "erp_active": "active",
  "erp_inactive": "inactive",
  "sort_order": "order",
  "new_erp": "New application",
  "create_erp_failed": "Could not create application",
  "update_erp_failed": "Could not update application",
  "threshold_failed": "Could not save threshold",
  "skill_scale": "Skill scale",
  "import_excel_erp": "Import Excel Applications",
  "import_excel_scale": "Import Excel scale (08)",
  "import_excel_threshold": "Import Excel threshold (09)",
  "level": "Level",
  "active_from": "Active from",
  "add_level": "Add level",
  "current": "Current",
  "undefined_value": "not set",
  "set_on": "set on",
  "save_threshold": "Save threshold",
  "bpml_ref_title": "BPML catalogue",
  "bpml_import_help": "Excel import → new version (inactive). SkillMap columns: domain, macroProcess, businessProcess, processCategory (+ subProcess, task). Corporate format accepted. Activation makes this the only active version. Multi-sheet template: data on the Donnees tab (not Guide). Application/feature links (N3) are set via the enrichment import below, not here.",
  "new_import": "New import",
  "version_label_ph": "Version label (e.g. BPML 2026-Q3)",
  "import_ok": "Import OK — {{imported}} line(s), domains {{domains}}. Enrichment carry-over: {{carriedOver}}. Version created inactive.",
  "versions": "Versions",
  "imported_on": "Imported on",
  "line_count": "Lines",
  "status_active": "Active",
  "status_inactive": "Inactive",
  "enrichment_title": "BPML enrichment",
  "enrichment_help": "Active version only. Edit complexity, label, critical, application scope and features; add Sub / Task. Bulk import available.",
  "critical_n": "{{count}} critical",
  "critical_col": "Critical",
  "critical_hint": "Critical column: tick to mark a process as critical (SPOF / continuity).",
  "no_critical_lines": "No critical lines — tick Critical on the relevant processes.",
  "reset_enrichment": "Reset enrichment",
  "confirm_reset_enrichment": "Reset enrichment for this version? Added sub-processes / tasks and critical flags will be lost.",
  "add_child": "Add child",
  "tv_catalog_title": "Transversal skills",
  "tv_include_archived": "Include archived",
  "archive": "Archive",
  "unarchive": "Unarchive",
  "version_label": "Label",
  "confirm_activate": "Activate this version? The current active version will be deactivated.",
  "import_ellipsis": "Import…",
  "erp_scope": "Application scope",
  "label": "Label",
  "domains": "Domains",
  "session_exists_id": "Session already exists — open it from the list ({{id}}…).",
  "select_domain_reset": "Select a domain to reset.",
  "select_parent_line": "Select a parent line.",
  "enrich_import_merge_hint": "Same hierarchy on several Excel rows with different applications → application scopes are merged onto a single BPML line.",
  "parent_line_ph": "Parent line…",
  "task_optional": "Task (optional)",
  "critical_only": "Critical only",
  "application_scope": "Application scope",
  "application_scope_ph": "App1, App2 (empty = all)",
  "application_scope_hint": "Multiple applications, comma-separated. Empty = applies to all.",
  "erp_scope_ph": "App1, App2 (empty = all)",
  "erp_scope_hint": "Multiple applications, comma-separated. Empty = applies to all.",
  "tv_macro_ph": "Macro / category",
  "tv_bp_ph": "Business process",
  "tv_sub_ph": "Sub process",
  "tv_task_ph": "Task",
  "sub_process": "Sub Process",
  "application_features": "Application features",
  "application_features_title": "Application features",
  "application_features_sub": "Manage application-specific features (transactions, modules) linked to BPML lines.",
  "new_feature": "New feature",
  "edit_feature": "Edit feature",
  "feature_code": "Code",
  "feature_label": "Label",
  "feature_application": "Application",
  "feature_application_required": "Please select an application for this feature.",
  "create_feature_failed": "Could not create feature",
  "update_feature_failed": "Could not update feature",
  "import_excel_features": "Import application features (Excel)",
  "features": "Features",
  "no_application": "No application (all BPML lines)",
  "application_optional": "Application (optional)",
  "application": "Application",
  "applications": "Applications",
  "environment": "Environment",
  "environments": "Environments",
  "nav_app_skills": "My Application Skills",
  "nav_transversal_skills": "My Transversal Skills",
  "my_transversal_skills_title": "My Transversal Skills",
  "my_transversal_skills_sub": "Self-assess transversal skills for the year. A single submission, validated by your manager.",
  "transversal_submission_status": "Submission",
  "submit_needs_all_scored": "All skills must be scored before submitting.",
  "transversal_validation_title": "Transversal validation",
  "validation_kind_process": "Process (BPML)",
  "validation_kind_transversal": "Transversal",
  "my_application_skills_title": "My Application Skills",
  "my_application_skills_sub": "Self-evaluate your application feature proficiency. Scores are shared across all your domain assessments for the year.",
  "select_application_hint": "Select an application to see its features.",
  "no_features_for_application": "No active features found for this application.",
  "saving": "Saving…",
  "saved": "Saved",
  "unsaved_changes": "Unsaved changes",
  "progress": "Progress",
  "all_applications": "All applications",
  "optional": "optional",
  "required_domain": "Domain is required.",
  "bulk_apply_button": "Apply to all empty features",
  "bulk_apply_title": "Pre-fill empty features",
  "bulk_apply_score_label": "Level to apply",
  "bulk_apply_none_empty": "All active features of this application are already scored.",
  "bulk_apply_confirm": "Apply level {{score}} to all currently empty features of this application? Features already scored individually will not be changed.",
  "bulk_apply_success": "{{count}} feature(s) pre-filled.",
  "bulk_apply_success_none": "No empty feature to pre-fill (everything was already scored).",
  "bulk_apply_failed": "Bulk-apply failed.",
  "bulk_apply_cancel": "Cancel"
}